<!-- 基本信息 -->
<template>
    <div class="container">
      <div class="vue">
        <div class="header   flex flexColumn">
          <div class="head-title borderB">
            <div class="text">随访记录</div>
          </div>
          <div class="headSearch">
            <div class="headSearch-left Fs14" style="width: 100%;">
              <div class="form-data group">
                <span>随访对象：</span>
                <el-input v-model="SearchForm.planInterviewee" style="width: 150px;" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>计划随访时间：</span>
                <el-date-picker v-model="SearchForm.planTime" style="width: 150px;" size="mini" type="date" placeholder="选择日期" clearable></el-date-picker>
              </div>
              <div class="form-data group">
                <span>实际随访时间：</span>
                <el-date-picker v-model="SearchForm.visitTime" style="width: 150px;" size="mini" type="date" placeholder="选择日期" clearable></el-date-picker>
              </div>
              <div class="form-data group" style="padding-left: 20px;">
                <span>是否登记：</span>
                <el-select v-model="SearchForm.hasVisit" style="width: 100px;" filterable placeholder="请选择" clearable>
                  <el-option v-for="item in hasVisitOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="form-data group">
                <el-button @click="SearchBut" round type="primary" size="mini">搜索</el-button>
                <el-button @click="recordAddBut" icon="el-icon-plus" round type="primary" size="mini">新增计划</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="content" style="padding-top: 20px;">
          <el-table
            :header-cell-style="{ background: '#f5f5f5' }"
            :data="recordList.list"
            style="width: 100%">
            <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
            <el-table-column prop="planInterviewee" label="随访对象" min-width="2"> </el-table-column>
            <el-table-column prop="planTime" label="计划随访时间" min-width="2">
              <template slot-scope="scope">
                <span>{{ scope.row.planTime | filterTime(1) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hasVisit" label="是否登记" min-width="2">
              <template slot-scope="scope">
                <span>{{ scope.row.hasVisit | filterHasVisit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="visitTime" label="正式随访时间" min-width="2">
              <template slot-scope="scope">
                <span>{{ scope.row.visitTime | filterTime(1) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="2">
              <template slot-scope="scope">
                <el-button @click="recordUpdateBut(scope.row)" type="primary" size="small">记录</el-button>
                <el-button @click="recordDeleteBut(scope.row)" type="danger" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="Pagination flex">
            <div class="text">
              <span>共{{ recordList.total }}条记录，</span>
              <span class="pageNum">{{ recordList.pageNum }}</span>
              <span>/{{ recordList.pages }}页</span>
            </div>
            <el-pagination
              v-if="recordList !== ''"
              @current-change="handleCurrentChange"
              :current-page.sync="recordList.pageNum"
              :page-size="recordList.pageSize"
              layout="prev, pager, next, jumper"
              :total="recordList.total">
            </el-pagination>
          </div>
        </div>
      </div>
  
    <!-- 表单详情 -->
    <el-dialog title="随访计划" width="800px" :visible.sync="recordDialogVisible" :append-to-body="true">
      <div>
        <el-form ref="recordForm" :model="recordForm" :rules="rules" label-width="80px">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col :span="12">
              <el-form-item label="随访对象" prop="personId">
                <el-select v-model="recordForm.personId" placeholder="请选择" filterable @change="bindPersonChange">
                  <el-option v-for="item in personOptions"
                    :key="item.id" :label="item.name + '/' +item.tel" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="对象姓名" prop="planInterviewee">
                <el-input v-model="recordForm.planInterviewee"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" align="middle">
            <el-col :span="12">
              <el-form-item label="随访时间" prop="planTime">
                <el-date-picker v-model="recordForm.planTime" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="随访人员" prop="planVisitor">
                <el-input v-model="recordForm.planVisitor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" align="middle">
            <el-col :span="24">
              <el-form-item label="随访事项" prop="planNote">
                <vue-ueditor-wrap class="ueditor" v-model="recordForm.planNote" :config="myConfig" ></vue-ueditor-wrap>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="recordAddClick">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 表单详情 -->
    <el-dialog title="随访管理" width="800px" :visible.sync="recordZsDialogVisible" :append-to-body="true">
      <div>
        <el-form ref="recordAllForm" :model="recordForm" :rules="rulesAll" label-width="80px">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="随访计划" name="first">
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="随访对象" prop="planInterviewee">
                    <el-input v-model="recordForm.planInterviewee" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="随访时间" prop="planTime">
                    <el-date-picker v-model="recordForm.planTime" type="date" placeholder="选择日期" disabled></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="24">
                  <el-form-item label="随访人员" prop="planVisitor">
                    <el-input v-model="recordForm.planVisitor" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="24">
                  <el-form-item label="随访事项" prop="planNote">
                    <vue-ueditor-wrap class="ueditor" v-model="recordForm.planNote" :config="myConfig" disabled></vue-ueditor-wrap>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="随访记录" name="second">
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="随访对象" prop="interviewee">
                    <el-input v-model="recordForm.interviewee" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="随访时间" prop="visitTime">
                    <el-date-picker v-model="recordForm.visitTime" type="date" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row><el-row type="flex" justify="space-between" align="middle">
                <el-col :span="24">
                  <el-form-item label="随访内容" prop="visitor">
                    <el-input v-model="recordForm.visitor" type="textarea"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="24">
                  <el-form-item label="随访事项特殊备注" prop="note">
                    <vue-ueditor-wrap class="ueditor" v-model="recordForm.note" :config="myConfig"></vue-ueditor-wrap>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="recordZsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="recordUpdateClick">确 定</el-button>
      </div>
    </el-dialog>
      
  
    </div>
  </template>
  
  <script>
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
  import { apiGetAccessRecord, apiGetAccessRecordPage, apiAddAccessRecord, apiUpdateAccessRecord, apiDeleteAccessRecord } from '@/api/clientManage'
import { apiGetSimpleAlertPerson } from '@/api/alertManage'
  import { apiUploadByBase64 } from '@/api/uploading'
  let _self
  export default {
    name: '',
    props: [''],
    data() {
      return {
        recordList: '', // 报告列表page
        personOptions: [],
        SearchForm: {
          planInterviewee: '',
          planTime: '',
          visitTime: '',
          hasVisit: '',
        },
        pages: {
          page: 1, // 页数
          size: 20
        },
        hasVisitOptions: [
          {label: '否', value: 1},
          {label: '是', value: 2},
        ],
        uploadActionUrl: '',
        myConfig: {
          UEDITOR_HOME_URL: '/UEditor/',
          serverUrl: '',
          // 工具栏是否可以浮动
          autoFloatEnabled: false
        },
        // 验证
        rules: {
          personId: [
            { required: true, message: '请选择计划随访对象', trigger: 'blur' },
          ],
          planInterviewee: [
            { required: true, message: '请输入计划随访姓名', trigger: 'blur' },
          ],
          planTime: [
            { required: true, message: '请选择计划随访时间', trigger: 'blur' },
          ],
          planVisitor: [
            { required: true, message: '请输入计划随访人员', trigger: 'blur' },
          ],
          planNote: [
            { required: true, message: '请输入计划随访事项', trigger: 'blur' },
          ],
        },
        rulesAll: {
          visitTime: [
            { required: true, message: '请选择随访时间', trigger: 'blur' },
          ],
          // interviewee: [
          //   { required: true, message: '请输入随访对象', trigger: 'blur' },
          // ],
          visitor: [
            { required: true, message: '请输入随访内容', trigger: 'blur' },
          ],
          // note: [
          //   { required: true, message: '请输入随访事项', trigger: 'blur' },
          // ],
        },
        // 记录
        activeName: 'second',
        lastPlanTime: null,
        lastVisitTime: null,
        recordForm: {},
        recordDialogVisible: false,
        recordZsDialogVisible: false,
      }
    },
  
    components: { VueUeditorWrap },
  
    computed: {},
  
    beforeMount() {},
  
    mounted() {
      _self = this
      this.myConfig.serverUrl = this.baseURL + '/ueditor/ueditorUpload.do'
      this.GetRecordList();
    },
  
    methods: {
      // 搜索
      SearchBut() {
        this.GetRecordList();
      },
      // 分页
      handleCurrentChange(val) {
        this.pages.page = val
        console.log(`当前页: ${val}`)
        this.GetRecordList()
      },
      // 接口
      // 获取基本用户的列表
      GetRecordList() {
        let planTimeLong = 0;
        let visitTimeLong = 0;
        if(this.SearchForm.planTime) {
          planTimeLong = this.SearchForm.planTime.getTime();
        }
        if(this.SearchForm.visitTime) {
          visitTimeLong = this.SearchForm.visitTime.getTime();
        }
        apiGetAccessRecordPage({
          planInterviewee: this.SearchForm.planInterviewee,
          planTimeLong: planTimeLong,
          visitTimeLong: visitTimeLong,
          hasVisit: this.SearchForm.hasVisit,
          page: this.pages.page,
          pageSize: this.pages.size
        }).then(res => {
          if (res.status === 0) {
            this.recordList = res.data
          }
        })
      },
      GetPersonList() {
        apiGetSimpleAlertPerson({}).then( res => {
          if(res.status == 0) {
            this.personOptions = res.data;
          }
        });
      },
      bindPersonChange() {
        this.personOptions.forEach( po=>{
          if(this.recordForm.personId == po.id) {
            this.recordForm.planInterviewee = po.name;
            return;
          }
        });
      },
      // 记录信息
      recordAddBut() {
        this.recordForm = {};
        this.recordDialogVisible = true;
        this.GetPersonList();
      },
      recordUpdateBut(row) {
        this.activeName = 'second';
        apiGetAccessRecord({
          id: row.id
        }).then(res => {
          if (res.status === 0) {
            this.recordForm = res.data;
            if(this.recordForm.visitTime) {
              this.recordForm.visitTime = new Date(this.recordForm.visitTime);
            }
            this.recordForm.interviewee = this.recordForm.planInterviewee;
            this.recordZsDialogVisible = true;
            this.GetPersonList();
          }
        })
      },
      recordDeleteBut(row){
        this.$confirm('确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            apiDeleteAccessRecord({id: row.id}).then(res => {
              if (res.status === 0) {
                this.$message({message: '删除成功', type: 'success'});
                this.GetRecordList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      },
      // 操作
      recordAddClick() {
        this.$refs['recordForm'].validate(valid => {
          if (valid) {
            let planTimeLong = this.recordForm.planTime.getTime();
            this.lastPlanTime = this.recordForm.planTime;
            delete this.recordForm.planTime;
            this.recordForm.planTimeLong = planTimeLong;
            this.recordForm.hasVisit = 1;
            apiAddAccessRecord(this.recordForm).then(res => {
              if (res.status === 0) {
                this.$message({message: '保存成功', type: 'success'});
                this.recordDialogVisible = false;
                this.recordForm = {};
                this.GetRecordList();
              } else {
                this.recordForm.planTime = this.lastPlanTime;
                this.$message({message: '上传失败', type: 'error'});
              }
            });
          }
        });
      },
      recordUpdateClick() {
        console.log(this.recordForm);
        this.$refs['recordAllForm'].validate(valid => {
          if (valid) {
            let visitTimeLong = this.recordForm.visitTime.getTime();
            this.lastVisitTime = this.recordForm.visitTime;
            delete this.recordForm.visitTime;
            this.recordForm.visitTimeLong = visitTimeLong;
            this.recordForm.hasVisit = 2;
            apiUpdateAccessRecord({
              id: this.recordForm.id,
              hasVisit: this.recordForm.hasVisit,
              visitTimeLong: this.recordForm.visitTimeLong,
              interviewee: this.recordForm.interviewee,
              visitor: this.recordForm.visitor,
              note: this.recordForm.note,
            }).then(res => {
              if (res.status === 0) {
                this.$message({message: '保存成功', type: 'success'});
                this.recordZsDialogVisible = false;
                this.recordForm = {};
                this.GetRecordList();
              } else {
                this.recordForm.visitTime = this.lastVisitTime;
                this.$message({message: '上传失败', type: 'error'});
              }
            });
          }
        });
      },
      handleClick() {
        
      }

    },
  
    watch: {}
  }
  </script>
  <style lang="scss" scoped>
  .flex {
    display: flex;
  }
  .FZ0875 {
    font-size: 0.875em;
  }
  .textalignLeft {
    text-align: left;
  }
  .vue {
    padding: 0 10px;
    background-color: #fff;
    border-left: 2px solid #119685;
    .header {
      height: 92px;
      .headSearch {
        .headSearch-left {
          width: 85%;
          float: left;
          .form-data {
            // span {
            //   width: 90px;
            // }
            /deep/ .el-date-editor,
            .el-input,
            .el-cascader {
              width: 200px;
            }
          }
        }
        .headSearch-right {
          width: 10%;
          float: right;
        }
      }
      .text {
        text-align: left;
        // font-size: 0.875em;
        color: #119685;
        padding: 10px 5px;
      }
    }
    .content {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: calc(100vh - 214px);
      /deep/ .el-table {
        overflow: auto;
        height: calc(100vh - 272px);
      }
      /deep/ .el-table .warning-row {
        background: oldlace;
      }
  
      /deep/ .el-table .success-row {
        background: #f0f9eb;
      }
      .Pagination {
        justify-content: space-between;
        padding: 10px 20px;
        align-items: center;
        font-size: 0.875em;
        color: #7b7b7b;
        .text {
          .pageNum {
            color: #119685;
          }
        }
      }
    }
  }
  .dialog {
  }
  </style>
  